export const FORM_LIST_SELECTED = 'FORM_LIST_SELECTED';
export const QUESTION_LIST_SELECTED = "QUESTION_LIST_SELECTED"